import { render, staticRenderFns } from "./manejoFechasCobro.vue?vue&type=template&id=6e8f7522&scoped=true"
import script from "./manejoFechasCobro.vue?vue&type=script&lang=js"
export * from "./manejoFechasCobro.vue?vue&type=script&lang=js"
import style0 from "./manejoFechasCobro.vue?vue&type=style&index=0&id=6e8f7522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8f7522",
  null
  
)

export default component.exports